/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beraterids2Inputs */

const en__field_beraterids2 = /** @type {(inputs: _Field_Beraterids2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berater IDs`)
};

const de__field_beraterids2 = /** @type {(inputs: _Field_Beraterids2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berater IDs`)
};

/**
* | output |
* | --- |
* | "Berater IDs" |
*
* @param {_Field_Beraterids2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_beraterids2 = /** @type {((inputs?: _Field_Beraterids2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beraterids2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_beraterids2(inputs)
	return de__field_beraterids2(inputs)
});
export { _field_beraterids2 as "_field_beraterIDs" }